<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{ $t("GENERAL_INFO") }}</span>
    </page-header>
    <left-menu />
    <v-card id="general-infomation">
      <v-tabs
        :value="currentTabIndex"
        @change="changeTab"
        background-color="transparent"
        class="main-tab-wrapper main-tab"
      >
        <v-tab
          v-for="tabItem in tabs"
          :tabindex="tabItem.index"
          :key="tabItem.index"
          @click="loadRoute(tabItem.routeName)"
          >{{ tabItem.label }}</v-tab
        >
      </v-tabs>
      <div class="main-content">
        <div class="content">
          <router-view></router-view>
        </div>
        <span class="tip mt-3" v-if="currentTabIndex == 2"
          >Tips: {{ $t("TIP_MAIN_IMAGE") }}.</span
        >
      </div>
    </v-card>
  </v-app>
</template>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import { Role } from "@/plugins/roles";

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu
  },
  data() {
    return {
      currentTabIndex: null,
      tabs: [
        {
          index: 0,
          label: this.$t("REGISTER_INFO"),
          routeName: "registerInfomation",
          roles: [Role.REGISTRATION_INFORMATION]
        },
        {
          index: 1,
          label: this.$t("EXTENSION"),
          routeName: "hotelAmenities",
          roles: [
							Role.HOTEL_AMENITY
						]
        },
        {
          index: 2,
          label: this.$t("IMAGES"),
          routeName: "hotelImages",
           roles: [
							Role.HOTEL_IMAGE
						]
        },
        {
          index: 3,
          label: this.$t("NEARBY_PLACE"),
          routeName: "nearby",
           roles: [
							Role.NEARBY_PLACE
						]
        },
        {
          index: 4,
          label: this.$t("HOTEL_CHAIN"),
          routeName: "hotelChain",
           roles: [
							Role.HOTEL_CHAIN
						]
        }
      ]
    };
  },
  created() {
    this.tabs = this.fnItemTab(this.tabs);
    switch (this.$route.name) {
      case "registerInfomation":
        this.currentTabIndex = 0;
        break;
      case "hotelAmenities":
        this.currentTabIndex = 1;
        break;
      case "hotelImages":
        this.currentTabIndex = 2;
        break;
      case "nearby":
        this.currentTabIndex = 3;
        break;
      case "hotelChain":
        this.currentTabIndex = 4;
        break;
    }
  },
  watch: {},
  methods: {
    changeTab(tabIndex) {
      this.currentTabIndex = tabIndex;
    },
    loadRoute(routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>
